<div class="content-wrapper blog-taxonomy-page">
    <div class="content-body">
        <section class="d-flex align-items-center justify-content-between mb-2">
            <div>
                <button type="button" class="btn btn-link p-0 text-muted" routerLink="/blogs">
                    <i class="fa fa-arrow-left mr-1"></i> Back to posts
                </button>
                <h2 class="mt-1 mb-0">Tags</h2>
                <p class="text-muted mb-0">Free-form labels to group related posts</p>
            </div>
            <button class="btn btn-primary" (click)="openCreate()">
                <i class="fa fa-plus mr-1"></i> New Tag
            </button>
        </section>

        <div class="card">
            <div class="card-body">
                <div *ngIf="!loading && tags.length === 0" class="text-center text-muted py-4">
                    No tags yet.
                </div>
                <div class="tag-cloud">
                    <div class="tag-row" *ngFor="let t of tags">
                        <span class="tag-pill">#{{ t.name }}</span>
                        <code class="ml-2 small">{{ t.slug }}</code>
                        <div class="ml-auto">
                            <button class="btn btn-sm btn-outline-primary btn-icon mr-1" (click)="openEdit(t)" aria-label="Edit">
                                <span [data-feather]="'edit-2'" [size]="14"></span>
                            </button>
                            <button class="btn btn-sm btn-outline-danger btn-icon" (click)="remove(t)" aria-label="Delete">
                                <span [data-feather]="'trash-2'" [size]="14"></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <ng-template #formModal let-modal>
            <div class="modal-header">
                <h5 class="modal-title">{{ editing ? 'Edit Tag' : 'New Tag' }}</h5>
                <button class="btn btn-sm btn-light btn-icon" (click)="modal.dismiss()" aria-label="Close">
                    <span [data-feather]="'x'" [size]="16"></span>
                </button>
            </div>
            <form [formGroup]="form" (ngSubmit)="submit(modal)">
                <div class="modal-body">
                    <label class="field-label">Name</label>
                    <input type="text" class="form-control" formControlName="name" autofocus>
                    <small class="text-danger"
                           *ngIf="form.get('name').touched && form.get('name').errors?.required">
                        Name is required
                    </small>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss()">Cancel</button>
                    <button type="submit" class="btn btn-primary" [disabled]="saving">
                        {{ editing ? 'Save' : 'Create' }}
                    </button>
                </div>
            </form>
        </ng-template>
    </div>
</div>
